import { useEffect } from "react";
import { Languages } from "lucide-react";

export const LanguageSelector = () => {
  useEffect(() => {
    if (window.__gtInjected) return;
    window.__gtInjected = true;
    window.googleTranslateElementInit = () => {
      /* eslint-disable no-new */
      new window.google.translate.TranslateElement(
        { pageLanguage: "en", autoDisplay: false },
        "google_translate_element"
      );
    };
    const s = document.createElement("script");
    s.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <div className="gt-wrap flex items-center gap-1.5" data-testid="language-selector" title="Translate this site">
      <Languages size={16} strokeWidth={2.5} className="text-[#E6B31E] flex-shrink-0" />
      <div id="google_translate_element" />
    </div>
  );
};
